import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ChestItem from '@/roc/effects/Production/ChestItem';

const BirdHouse = {
  id: '85',
  name: 'BirdHouse',
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Bird_House',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Bird_House',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(3),
      [
        ProductionCost.asFlat(16).withCurrency(ProductionCurrency.RANGED_UNITS),
      ],
      ProductionDuration.asHourMinutePerLevel([
        [24,  0], [23, 50], [23, 40], [23, 30], [23, 20],
        [23, 10], [23,  0], [22, 50], [22, 40], [22, 30],
        [21, 49], [21, 23], [21,  0], [20, 39], [20, 19],
        [20,  1], [19, 44], [19, 29], [19, 15], [19,  1],
        [18, 49], [18, 37], [18, 26], [18, 16], [18,  6],
        [17, 57], [17, 48], [17, 40], [17, 33], [17, 25],
        [17, 18], [17, 12], [17,  5], [16, 59], [16, 54],
        [16, 48], [16, 43], [16, 38], [16, 33], [16, 28],
      ]),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.CHEST).withItems([
        ChestItem.asFlat(1).withChance(50).withOutput(ProductionOutputType.NEGOTIATION_JOKER),
        ChestItem.asFlat(1).withChance(50).withOutput(ProductionOutputType.RANDOM_BARRACKS_REFILL),
      ]),
    ),
  ]),
};

export default BirdHouse;
